export default __webpack_public_path__ + "static/media/profileImage.e517f772.svg";